import {
  Button,
  Divider,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Fragment, useState } from "react";
import { FlexBox } from "@/components/baseComponents/FlexBox";
import Eye from "@/components/icons/Eye";
import EyeOff from "@/components/icons/EyeOff";
import {
  StyledContainer,
  StyledForm,
  StyledInputItem,
  StyledInputLabel,
  StyledLandingCard,
  StyledRobot,
} from "./LoginPage.styles";
import { useGetMoeLoginUrlQuery } from "@/apis/oneclubMoe/hooks/users";
import { isOneClassDomain, isLocalhost } from "@/utils/auth/helpers";
import useLogin from "./useLogin";

const LINKS = [
  {
    label: "忘記密碼",
    href: "https://oneclub.oneclass.com.tw/forgetpassword/",
  },
  { label: "前往註冊", href: "https://oneclub.oneclass.com.tw/signup/" },
];

const LoginPage = () => {
  const { handleSubmit } = useLogin();
  const [isPasswordShown, setIsPasswordShown] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { data: moeLoginData } = useGetMoeLoginUrlQuery();
  const moeLoginUrl = moeLoginData?.url ?? null;
  const isMoeLoginEnabled = isOneClassDomain || isLocalhost;

  return (
    <StyledContainer>
      <StyledLandingCard>
        <StyledForm>
          <Stack
            sx={{ rowGap: "52px" }}
            component="form"
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit(username, password);
            }}
          >
            <Stack sx={{ rowGap: "20px" }}>
              <Typography variant="h3">登入</Typography>
              <StyledInputItem>
                <StyledInputLabel>帳號</StyledInputLabel>
                <TextField
                  placeholder="請輸入帳號"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  slotProps={{ htmlInput: { autoComplete: "username" } }}
                />
              </StyledInputItem>
              <StyledInputItem>
                <StyledInputLabel>密碼</StyledInputLabel>
                <TextField
                  type={isPasswordShown ? "text" : "password"}
                  placeholder="請輸入密碼"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  slotProps={{
                    htmlInput: { autoComplete: "current-password" },
                    input: {
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          onClick={() => setIsPasswordShown((prev) => !prev)}
                        >
                          <IconButton
                            aria-label={`${
                              isPasswordShown ? "隱藏" : "顯示"
                            }密碼`}
                          >
                            {isPasswordShown ? (
                              <Eye width={24} />
                            ) : (
                              <EyeOff width={24} />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </StyledInputItem>
            </Stack>
            <Button type="submit" disabled={!username || !password}>
              登入
            </Button>
          </Stack>
          {isMoeLoginEnabled && (
            <>
              <Divider>或</Divider>
              <Button
                color="secondary"
                startIcon={
                  <img
                    src="/loginPage/moe-logo.svg"
                    alt=""
                    width={20}
                    height={20}
                  />
                }
                href={moeLoginUrl || undefined}
                disabled={!moeLoginUrl}
              >
                教育雲端帳號登入
              </Button>
            </>
          )}
          <FlexBox sx={{ columnGap: "24px", alignSelf: "center" }}>
            {LINKS.map(({ href, label }, i, arr) => (
              <Fragment key={label}>
                <Button
                  size="small"
                  variant="text"
                  href={href}
                  target="_blank"
                  color="inherit"
                  sx={{ padding: "4px" }}
                >
                  {label}
                </Button>
                {i !== arr.length - 1 && (
                  <Divider orientation="vertical" flexItem />
                )}
              </Fragment>
            ))}
          </FlexBox>
        </StyledForm>
        <StyledRobot>
          <img
            src="/loginPage/robot.webp"
            alt=""
            width={480}
            height={614}
            loading="lazy"
          />
        </StyledRobot>
      </StyledLandingCard>
    </StyledContainer>
  );
};

export default LoginPage;
